export default (text: string) => {
  const charactersMap = {
    '&amp;': '&',
    '&gt;': '>',
    '&lt;': '<',
  }

  const r = new RegExp(`${Object.keys(charactersMap).join('|')}`, 'g')

  return text.replace(r, c => charactersMap[c])
}
